import { StyledDataGrid } from "../../helpers/appHelpers";
import { Box } from "@mui/material";
import CustomPagination from "./CustomPagination";
import useEditFormStore from "../../state-management/useEditFormStore";

interface ICustomStyledTable {
	rows: any[];
	columns: any[];
	apiRef: any;
	columnVisibilityModel?: Record<string, boolean>;
	loading?: boolean;
	height?: number | string;
	pageCount?: number;
	pagination?: any;
	uniqueRowField?: string;
	setAnchorEl?: (value: React.SetStateAction<HTMLButtonElement | null>) => void;
	conditionalRowAction?: (params: any) => boolean;
	hasPermission?: boolean;
}

const CustomStyledTable = ({
	rows,
	columns,
	apiRef,
	columnVisibilityModel,
	loading,
	height,
	pageCount,
	pagination,
	uniqueRowField,
	setAnchorEl,
	conditionalRowAction,
	hasPermission,
}: ICustomStyledTable) => {
	const { setFormData } = useEditFormStore();

	const CustomNoRowsOverlay = () => {
		return (
			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
					justifyContent: "center",
					height: "100%",
				}}
			>
				<Box sx={{ mt: 1 }}>
					<p className="text-2sm text-black">
						You are not authorized to access this data.
					</p>
				</Box>
			</Box>
		);
	};

	return (
		<Box
			sx={{
				height: height ? height : "530px",
				backgroundColor: "background.paper",
				borderRadius: 4,
				width: "100%",
				overflow: "hidden",
				display: "flex",
				flexDirection: "column",
				"& .actions": {
					color: "text.secondary",
				},
				"& .textPrimary": {
					color: "text.primary",
				},
				"& .super-app-theme--header": {
					backgroundColor: "#F2F2F4",
					fontWeight: "bold",
				},
				"& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
					width: "16px",
				},
				"& .MuiDataGrid-virtualScroller::-webkit-scrollbar-track": {
					background: "#f7fafc",
				},
				"& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb": {
					backgroundColor: "#e2e8f0",
					borderRadius: "8px",
					border: "3px solid #f7fafc",
				},
				"& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb:hover": {
					backgroundColor: "#cbd5e0",
					borderRadius: "7px",
					border: "3px solid #f7fafc",
				},
				textOverflow: "ellipsis",
			}}
		>
			<StyledDataGrid
				rows={rows}
				rowHeight={65}
				columnHeaderHeight={70}
				columns={columns}
				loading={
					hasPermission !== undefined
						? hasPermission
							? loading
							: false
						: loading
				}
				initialState={{
					pagination: {
						paginationModel: {
							// pageSize: 6,
						},
					},
					columns: {
						columnVisibilityModel: {
							id: false,
							...columnVisibilityModel,
						},
					},
				}}
				slots={{
					pagination: () =>
						pagination !== undefined ? (
							pagination
						) : (
							<CustomPagination pageCount={pageCount} />
						),
					...(!hasPermission &&
						hasPermission !== undefined && {
							noRowsOverlay: CustomNoRowsOverlay,
						}),
				}}
				pageSizeOptions={[5]}
				getRowClassName={(params) => `truncate 
                    ${
											params.indexRelativeToCurrentPage % 2 === 0
												? "even-row"
												: "odd-row"
										}
                    ${
											conditionalRowAction
												? conditionalRowAction(params)
													? "cursor-pointer"
													: ""
												: setAnchorEl
												? "cursor-pointer"
												: ""
										}
                `}
				apiRef={apiRef}
				getRowId={(row) => (uniqueRowField ? row[uniqueRowField] : row.id)}
				onCellClick={(params, event: any) => {
					if (conditionalRowAction) {
						if (conditionalRowAction(params) && setAnchorEl) {
							setAnchorEl(event.currentTarget);
							setFormData(params.row);
						}
					} else {
						if (setAnchorEl) {
							setAnchorEl(event.currentTarget);
							setFormData(params.row);
						}
					}
				}}
				sx={{ overflow: "auto" }}
			/>
		</Box>
	);
};

export default CustomStyledTable;
